import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

const stats = [
  { number: '2800+', label: '漫画作品' },
  { number: '150万+', label: '注册读者' },
  { number: '5000万+', label: '累计阅读' },
  { number: '99.9%', label: '服务可用率' },
];

const features = [
  {
    icon: 'ri-shield-check-line',
    title: '正版授权',
    desc: '所有漫画内容均获得版权方正式授权，为读者提供合法合规的阅读环境，保护创作者权益。',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配',
    desc: '支持PC、平板、手机等多终端流畅阅读，智能适配不同屏幕尺寸，随时随地享受阅读。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续更新',
    desc: '编辑团队每日更新漫画资源，热门连载作品保证稳定更新频率，让您追更无忧。',
  },
  {
    icon: 'ri-lock-line',
    title: '安全私密',
    desc: '采用先进的加密技术保护用户隐私数据，提供安全可靠的阅读环境，让您安心阅读。',
  },
  {
    icon: 'ri-star-line',
    title: '精选内容',
    desc: '专业编辑团队精心筛选优质漫画，从海量作品中为您推荐最值得阅读的精品内容。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心客服',
    desc: '7×24小时客服支持，快速响应您的每一个问题和建议，持续优化阅读体验。',
  },
];

const testimonials = [
  {
    name: '漫画爱好者小王',
    text: 'h漫画是我用过最好的成人漫画平台，分类清晰、更新及时，推荐的作品质量都很高。',
    rating: 5,
  },
  {
    name: '资深读者李女士',
    text: '从日系到韩漫，画风多样，内容优质。正版授权让我看得放心，推荐给所有漫画爱好者。',
    rating: 5,
  },
  {
    name: '新媒体人张先生',
    text: '手机端阅读体验非常流畅，地铁上也能轻松追更。界面设计简洁大方，使用体验极佳。',
    rating: 5,
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于h漫画 - 精选成人漫画在线阅读平台',
            description: 'h漫画品牌介绍，了解我们的故事、平台优势与联系方式。',
            url: 'https://hmanga.com/about',
            isPartOf: { '@type': 'WebSite', name: 'h漫画', url: 'https://hmanga.com' },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://hmanga.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们' },
            ],
          }),
        }}
      />

      <div className="pt-20">
        <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '关于我们' }]} />

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              关于h漫画
            </h1>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              h漫画成立于2020年，是专为成熟读者打造的在线漫画阅读平台。
              我们致力于汇聚全球优质成人漫画资源，为读者提供高品质、正版授权的阅读体验。
            </p>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-6 bg-background-50 rounded-lg border border-background-200">
                  <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.number}</p>
                  <p className="text-sm text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                平台优势
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                为什么选择h漫画？六大核心优势为您保驾护航
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map((feat) => (
                <div key={feat.title} className="p-6 bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 transition-colors">
                  <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center text-primary-600 mb-4">
                    <i className={`${feat.icon} text-xl w-6 h-6 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">{feat.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                读者评价
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                听听读者们怎么说
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((t) => (
                <div key={t.name} className="p-6 bg-background-50 rounded-lg border border-background-200">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }, (_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">{t.text}</p>
                  <p className="text-xs text-foreground-500 font-medium">{t.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                如有任何问题或建议，欢迎通过以下方式联系我们
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center p-6 bg-background-50 rounded-lg border border-background-200">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 mx-auto mb-4">
                  <i className="ri-mail-line text-xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h4 className="font-medium text-foreground-900 text-sm mb-1">电子邮箱</h4>
                <p className="text-xs text-foreground-500">contact@hmanga.com</p>
              </div>
              <div className="text-center p-6 bg-background-50 rounded-lg border border-background-200">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 mx-auto mb-4">
                  <i className="ri-qq-line text-xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h4 className="font-medium text-foreground-900 text-sm mb-1">客服QQ</h4>
                <p className="text-xs text-foreground-500">1234567890</p>
              </div>
              <div className="text-center p-6 bg-background-50 rounded-lg border border-background-200">
                <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-600 mx-auto mb-4">
                  <i className="ri-time-line text-xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h4 className="font-medium text-foreground-900 text-sm mb-1">工作时间</h4>
                <p className="text-xs text-foreground-500">周一至周日 9:00-22:00</p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}